export const config = {
  resetSelectedAppointmentType: true,
  hideAddress: true,
  ignoreAppointmentType: true,
};
